export const refreshCacheAndReload = async (): Promise<void> => {
  if (window.caches) {
    const names = await window.caches.keys();
    const deletePromises = names.map((name) => window.caches.delete(name));
    await Promise.all(deletePromises);
  }
  window.location.reload();
};
